"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Navigation = void 0;
exports.hasNavigation = hasNavigation;
var config_1 = require("../config");
var get_closest_1 = require("../helper/get-closest");
var Navigation = /*#__PURE__*/function () {
  function Navigation() {
    var _this = this;
    _classCallCheck(this, Navigation);
    this.body = null;
    this.navigation = null;
    this.toggleNavigationButton = null;
    this.toggleSubMenuButtons = null;
    this.toggleNavigationParentsButtons = null;
    this.navigationItems = null;
    this.body = document.querySelector(config_1.CONFIG.body);
    this.navigation = document.querySelector(config_1.CONFIG.navigation.main);
    this.toggleNavigationButton = document.querySelector(config_1.CONFIG.navigation.toggleButton);
    this.toggleSubMenuButtons = document.querySelectorAll(config_1.CONFIG.navigation.toggleSubMenuButton);
    this.toggleNavigationParentsButtons = document.querySelectorAll(config_1.CONFIG.navigation.toggleParent);
    this.navigationItems = document.querySelectorAll(config_1.CONFIG.navigation.navigationItem);
    this.toggleNavigationButton.addEventListener('click', this.toggleNavigation.bind(this));
    if (this.toggleSubMenuButtons.length > 0) {
      [].forEach.call(this.toggleSubMenuButtons, function (button) {
        button.addEventListener('click', _this.toggleSubMenu.bind(_this));
      });
    }
    if (this.toggleNavigationParents.length > 0) {
      [].forEach.call(this.toggleNavigationParentsButtons, function (button) {
        button.addEventListener('click', _this.toggleSubMenu.bind(_this));
      });
    }
  }
  return _createClass(Navigation, [{
    key: "toggleNavigation",
    value: function toggleNavigation(event) {
      event.preventDefault();
      var button = (0, get_closest_1.getClosest)(config_1.CONFIG.navigation.toggleButton, event.target);
      if (button.classList.contains(config_1.CONFIG.navigation.activeClass)) {
        this.body.classList.remove(config_1.CONFIG.navigation.wrapperClass);
        this.navigation.classList.remove(config_1.CONFIG.navigation.activeClass);
        button.classList.remove(config_1.CONFIG.navigation.activeClass);
      } else {
        this.body.classList.add(config_1.CONFIG.navigation.wrapperClass);
        this.navigation.classList.add(config_1.CONFIG.navigation.activeClass);
        button.classList.add(config_1.CONFIG.navigation.activeClass);
        if (this.toggleSubMenuButtons.length > 0) {
          [].forEach.call(this.toggleSubMenuButtons, function (toggleButton) {
            toggleButton.classList.remove(config_1.CONFIG.navigation.activeClass);
          });
        }
      }
    }
  }, {
    key: "toggleNavigationParents",
    value: function toggleNavigationParents(event) {
      event.preventDefault();
      console.log('clicked!');
      var navigationItem = (0, get_closest_1.getClosest)(config_1.CONFIG.navigation.navigationItem, event.target);
      if (navigationItem.classList.contains(config_1.CONFIG.navigation.activeClass)) {
        navigationItem.classList.remove(config_1.CONFIG.navigation.activeClass);
      } else {
        [].forEach.call(this.navigationItems, function (navItem) {
          navItem.classList.remove(config_1.CONFIG.navigation.activeClass);
        });
        navigationItem.classList.add(config_1.CONFIG.navigation.activeClass);
      }
    }
  }, {
    key: "toggleSubMenu",
    value: function toggleSubMenu(event) {
      event.preventDefault();
      var button = (0, get_closest_1.getClosest)(config_1.CONFIG.navigation.navigationItem, event.target);
      if (button.classList.contains(config_1.CONFIG.navigation.activeClass)) {
        button.classList.remove(config_1.CONFIG.navigation.activeClass);
      } else {
        [].forEach.call(this.navigationItems, function (subMenuButton) {
          subMenuButton.classList.remove(config_1.CONFIG.navigation.activeClass);
        });
        button.classList.add(config_1.CONFIG.navigation.activeClass);
      }
    }
  }]);
}();
exports.Navigation = Navigation;
function hasNavigation() {
  if (document.querySelector(config_1.CONFIG.navigation.main)) {
    return true;
  }
  return false;
}